import React, { FunctionComponent } from 'react'

import iconExtrato from '../../../assets/icons/pagamentos/icon-extrato.svg'
import { Icon } from '../styles'
import { IconsProp } from '../Icons.type'

const IconExtrato: FunctionComponent<IconsProp> = ({ size }) => (
  <Icon src={iconExtrato} size={size} />
)
export default IconExtrato
